
import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from './components/navbar/Navbar';

//pages
import { Home } from './components/pages/Home';
import AboutUs from './components/pages/AboutUs';
import ContactPage from './components/pages/ContactPage';
import Founder from './components/pages/Founder';
import 'leaflet/dist/leaflet.css';
import Footer from './components/pages/Footer';
import ProductLists from './components/pages/ProductLists';
import ProductDetails from './components/pages/ProductDetails';
import ScrollToTop from './components/ScrollToTop';
function App() {
  return (
    <BrowserRouter>
     <ScrollToTop/>
      <div className="navfix1 fixed-top">
        <Navbar />
      </div>

      <div className="container-fluid"  style={{ marginTop: "60px",padding:"0px"}} >
        <div className="pages" >
          <Routes>
           
            <Route path="/" element={<Home/>} /> 
            <Route path="/Aboutus" element={<AboutUs/>} />
            <Route path="/Contact" element={<ContactPage/>} />
             <Route path="/founder" element={<Founder/>} />
             <Route path="/products/:category" element={<ProductLists />} />
            <Route path="/product/:id" element={<ProductDetails />} />{/* Third page */}
            </Routes>
        </div>
      </div>

      {/* <Footer /> */}
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
